import type { ComponentProps } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@shared/lib';

export type LabelProps = ComponentProps<typeof LabelPrimitive.Root>;

/**
 * Form field label. Built on Radix Label so clicking it focuses the associated control
 * (via `htmlFor`). Used standalone or by `Field`.
 */
export function Label({ className, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'select-none text-sm font-medium text-fg peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
